import { AuthService } from './auth.service';
import {Injectable} from '@angular/core';
import {CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot} from '@angular/router';

@Injectable()
export class LoginGuardService implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthService,
  ) {
  }

  checkRole() {
    if (!this.authService.isLoggedIn()) {

      if (window.location.href.indexOf('login-redirect') < 0) {
        localStorage.setItem('configMenu', '');
        this.authService.login();
      }
      // clear danh sách các quyền của user đăng nhập
      // GlobalVariable.userActionGroups = [];
      return false;
    } else if (window.location.href.indexOf('?postLogout=true') > 0) {
      this.authService.signoutRedirectCallback().then(async () => {
        const url: string = this.router.url.substring(0, this.router.url.indexOf('?'));
        this.router.navigateByUrl(url);
        return false;
      });
      return false;
    }
    return true;
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkRole();
  }
}
